import React from 'react';

import Navbar from "../components/Navbar";
import SEO from "../components/SEO";

import arrow from "../Assets/Back.png";
import line from "../Assets/Rectangle 40191.svg";
import copy from "../Assets/Group 1190.png";
import radio from "../Assets/radio-minimalistic-svgrepo-com 1.svg";


import playstore from "../Assets/Mobile app store badge-1.svg";
import appstore from "../Assets/Mobile app store badge.svg";
import dot from "../Assets/“.svg";
import star from "../Assets/Group 62.svg";

import profile from "../Assets/Ellipse 15.png";
import part1 from "../Assets/user-check-rounded-svgrepo-com 4.svg";
import sp1 from "../Assets/image 103.png";
import Footer from "../components/Footer";
import s1 from '../Assets/cinema-clapboard-svgrepo-com 1.svg'
import s2 from '../Assets/digital-content-content-read-look-at-pictures-svgrepo-com 1.svg'
import s3 from '../Assets/viral-marketing-svgrepo-com 1.svg'
import s4 from '../Assets/flight-plane-svgrepo-com 1.svg'
import s5 from '../Assets/television-technology-entertainment-svgrepo-com 1.svg'
import s6 from '../Assets/car-svgrepo-com 1.svg'
import s7 from '../Assets/news-paper-svgrepo-com 1.svg'
import s8 from '../Assets/billboard 1.svg'
import s9 from '../Assets/wheel-svgrepo-com 1.svg'
import s10 from '../Assets/magazine-svgrepo-com 1.svg'
import slid from '../Assets/image 14.svg'
import a2 from '../Assets/Indorinama-Page 2-1.svg'
import a1 from '../Assets/Indorinama-Page 2.svg'

import a3 from '../Assets/Indorinama-Page 2-2.svg'
import a4 from '../Assets/Indorinama-Page 2-3.svg'
import a5 from '../Assets/Indorinama-Page 2-4.svg'
import part2 from '../Assets/team-3-svgrepo-com 4.svg'
import part3 from '../Assets/media-svgrepo-com 4.svg'
import part4 from '../Assets/team-member-svgrepo-com 4.svg'
import part5 from '../Assets/marketing-mail-svgrepo-com 4.svg'
import part6 from '../Assets/chart-bar-vertical-svgrepo-com 4.svg'

const Carousel = ({ slides }) => {
  const currentSlide = 0;
  return (
    <div className="carousel">
      {/* <button className='prv-btn' onClick={() => handleSlideChange(-1)}><img alt="" src={next}/></button> */}
      <div className="slide">{slides[currentSlide]}</div>
      {/* <button className='nxt-btn' onClick={() => handleSlideChange(1)}><img alt="" src={pervious}/></button> */}
    </div>
  );
};

function CorporrateGiftingHome() {
  const slideContent = [
    <div key={1} className='slide-cont'>
  <div className='slide-left'>
  <h1>Sell Old Phone</h1>
    <p>From Your Doorstep or at any of our 200<br/> 
    stores Pan India</p>
<button>Sell Now</button>
  </div>
  <div className='slide-right'>
  <img alt="" src={slid}/>

  </div>
    </div>,
    <div key={2} className='slide-cont'><div className='slide-left'>
    <h1>Sell Old Phone2</h1>
      <p>From Your Doorstep or at any of our 200<br/> 
      stores Pan India</p>
  <button>Sell Now</button>
    </div>
    <div className='slide-right'>
    <img alt="" src={slid}/>
  
    </div></div>,
    <div key={3} className='slide-cont'><div className='slide-left'>
    <h1>Sell Old Phone3</h1>
      <p>From Your Doorstep or at any of our 200<br/> 
      stores Pan India</p>
  <button>Sell Now</button>
    </div>
    <div className='slide-right'>
    <img alt="" src={slid}/>
  
    </div></div>,
    // Add more slides as needed
];
  return (
    <>
      <SEO
        title="Corporate Gifting"
        description="Premium corporate gifting solutions for businesses. Find unique branded gifts, corporate merchandise, and custom gift solutions at Indorinama."
        keywords="corporate gifting, business gifts, branded merchandise, corporate gifts India, bulk gifting"
        url="https://indorinama.com/corporratehome"
      />
  <div className='homepage'>
      <Navbar/>
      <br/>
    
      <div className='home-slider'>
      <div className="apps">
     
      <Carousel slides={slideContent} />
    </div>

      </div>
      <br/>

      <div className="services">
        <div className="services-sections">
          <div className="services-section">
            <div className="services-card">
              <img alt="" src={radio} />
              <p>Radio</p>
            </div>
            <div className="services-card">
              <img alt="" src={s1} />
              <p>Cinema</p>
            </div>
            <div className="services-card">
              <img alt="" src={s2} />
              <p>Digital</p>
            </div>
            <div className="services-card">
              <img alt="" src={s3} />
              <p>Influencer</p>
            </div>
            <div className="services-card">
              <img alt="" src={s4} />
              <p>Airport</p>
            </div>
            <div className="services-card">
              <img alt="" src={s5} />
              <p>Television</p>
            </div>
            <div className="services-card">
              <img alt="" src={s6} />
              <p>BTL</p>
            </div>
            <div className="services-card">
              <img alt="" src={s7} />
              <p>News paper</p>
            </div>
            <div className="services-card">
              <img alt="" src={s8} />
              <p>Outdoor</p>
            </div>
            <div className="services-card">
              <img alt="" src={s9} />
              <p>Transit</p>
            </div>
            <div className="services-card">
              <img alt="" src={s10} />
              <p>Magzine</p>
            </div>
            <div className="viewall">
              <p>View More</p>
              <img alt="" src={arrow} />
            </div>
          </div>
       
        </div>
      </div>
      <br/>


      <div className="trendingOffer">
        <div className="trendingOffer-section">
          <div className="trendingOffer-section-heading">
            <img alt="" src={line} />
            <h1>Trendings Offers</h1>
          </div>
          <div className="slide">
         <div className="slidess">
         <div className="window">
              <div className="bus">BUS</div>
              <h2>
                Save up to Rs 250 on
                <br />
                bus tickets
              </h2>
              <p>Valid Till 30 Sep</p>
              <button>First</button>
              <img alt="" src={copy} />
            </div>
            <div className="window">
              <div className="bus">BUS</div>
              <h2>
                Save up to Rs 250 on
                <br />
                bus tickets
              </h2>
              <p>Valid Till 30 Sep</p>
              <button>First</button>
              <img alt="" src={copy} />
            </div>
            <div className="window">
              <div className="bus">BUS</div>
              <h2>
                Save up to Rs 250 on
                <br />
                bus tickets
              </h2>
              <p>Valid Till 30 Sep</p>
              <button>First</button>
              <img alt="" src={copy} />
            </div>
         </div>
          </div>
        </div>
      </div>

      <div className="dowmloadapp-section">
        <div className="dowmloadapp">
          <h1>Download the App</h1>
          <p>
            Sell your old phone | Buy top-qulaity refurbished phones |<br /> Get
            your phone repaired
          </p>
          <div className="browser">
            <img alt="" src={playstore} />
            <img alt="" src={appstore} />
          </div>
        </div>
      </div>
      <br/>
      <div className='catg-section'>
      <div className='catg'>

      <div className='catg-card'>
      <div className='catg-img'>

      </div>
      <p>Smart Devices</p>

</div>
  <div className='catg-card'>
      <div className='catg-img'>

      </div>
      <p>Smart Devices</p>

</div>
  <div className='catg-card'>
      <div className='catg-img'>

      </div>
      <p>Smart Devices</p>

</div>
  <div className='catg-card'>
      <div className='catg-img'>

      </div>
      <p>Smart Devices</p>

</div>
  <div className='catg-card'>
      <div className='catg-img'>

      </div>
      <p>Smart Devices</p>

</div>
  <div className='catg-card'>
      <div className='catg-img'>

      </div>
      <p>Smart Devices</p>

</div>
  <div className='catg-card'>
      <div className='catg-img'>

      </div>
      <p>Smart Devices</p>

</div>

</div>

      </div>
      <div className="dowmloadapp-section">
        <div className="dowmloadapp">
          <h1>Download the App</h1>
          <p>
            Sell your old phone | Buy top-qulaity refurbished phones |<br /> Get
            your phone repaired
          </p>
          <div className="browser">
            <img alt="" src={playstore} />
            <img alt="" src={appstore} />
          </div>
        </div>
      </div>
      <br/>
      <br/>
      
      <div className="clients">
        <div className="trendingOffer-section-heading">
          <img alt="" src={line} />
          <h1>What Our Clients Say</h1>
        </div>
       <div className="review-section">
       <div className="reviews">
          <div className="review-card">
            <img alt="" className="dot" src={dot} />
            
            <p>
              Cashify has been a Fantastic Startup that has brought so much
              value to the Indian customer.we are Proud to partner with them and
              help our Mi fans get better exchange value for our phones!
            </p>
            <br />

            <p>
              Manu jain is a leading indian entrepreneur & VP of Xiaomi which is
              one of india,s Largest smartphone Brands.
            </p>
            <div className="user">
              <img alt="" src={profile} />
              <div>
                <h1>Manu Jain</h1>
                <p>VP & MD, Xiaomi India</p>
              </div>
              <img alt="" src={star} />
            </div>
          </div>
          <div className="review-card">
            <img alt="" className="dot" src={dot} />
            <p>
              Cashify has been a Fantastic Startup that has brought so much
              value to the Indian customer.we are Proud to partner with them and
              help our Mi fans get better exchange value for our phones!
            </p>
            <br />

            <p>
              Manu jain is a leading indian entrepreneur & VP of Xiaomi which is
              one of india,s Largest smartphone Brands.
            </p>
            <div className="user">
              <img alt="" src={profile} />
              <div>
                <h1>Manu Jain</h1>
                <p>VP & MD, Xiaomi India</p>
              </div>
              <img alt="" src={star} />
            </div>
          </div>
          <div className="review-card">
            <img alt="" className="dot" src={dot} />
            <p>
              Cashify has been a Fantastic Startup that has brought so much
              value to the Indian customer.we are Proud to partner with them and
              help our Mi fans get better exchange value for our phones!
            </p>
            <br />

            <p>
              Manu jain is a leading indian entrepreneur & VP of Xiaomi which is
              one of india,s Largest smartphone Brands.
            </p>
            <div className="user">
              <img alt="" src={profile} />
              <div>
                <h1>Manu Jain</h1>
                <p>VP & MD, Xiaomi India</p>
              </div>
              <img alt="" src={star} />
            </div>
          </div>
          <div className="review-card">
            <img alt="" className="dot" src={dot} />
            <p>
              Cashify has been a Fantastic Startup that has brought so much
              value to the Indian customer.we are Proud to partner with them and
              help our Mi fans get better exchange value for our phones!
            </p>
            <br />

            <p>
              Manu jain is a leading indian entrepreneur & VP of Xiaomi which is
              one of india,s Largest smartphone Brands.
            </p>
            <div className="user">
              <img alt="" src={profile} />
              <div>
                <h1>Manu Jain</h1>
                <p>VP & MD, Xiaomi India</p>
              </div>
              <img alt="" src={star} />
            </div>
          </div>
        </div>
       </div>
      </div>

      <div className="partner-section">
        <div className="partner">
          <div className="trendingOffer-section-heading">
            <img alt="" src={line} />
            <h1>Your Perfect Advertising Partner</h1>
          </div>
          <p>
            Excellent Publicity is forever expanding your brand with high
            quality service that combines creativity with value pricing. We
            enjoy
            <br />
            our work because, first - we admire the advertising world, and
            second, we know that our ideas and strategies make a difference.{" "}
            <br />
            We play to win, with the primary goal of assisting our customers in
            promoting their successful brand campaigns.
          </p>

          <div className="partner-cards">
            <div className="partner-card">
              <img alt="" src={part1} />
              <p>Happy Clients</p>
            </div>
         
            <div className="partner-card">
              <img alt="" src={part2} />
              <p>Qualified Team Members</p>
            </div>
            <div className="partner-card">
              <img alt="" src={part3} />
              <p>Media Options</p>
            </div>
            <div className="partner-card">
              <img alt="" src={part4} />
              <p>Vendor tie-ups</p>
            </div>
            <div className="partner-card">
              <img alt="" src={part5} />
              <p>Compaigns</p>
            </div>
            <div className="partner-card">
              <img alt="" src={part6} />
              <p>Varticals</p>
            </div>
          </div>
          <button>
            About us
            <img alt="" src={arrow} />
          </button>
        </div>
      </div>
      <br />

      <div>
        <div className="trendingOffer-section-heading">
          <img alt="" src={line} />
          <h1>Our Venture</h1>
        </div>
     <div className="sponser-div">
     <div className="sponser">
          <img alt="" src={sp1} />
          <img alt="" src={a1} />
          <img alt="" src={a2} />
          <img alt="" src={a3} />
          <img alt="" src={a4} />
          <img alt="" src={a5} />
        </div>
     </div>
      </div>
      <br/>

<Footer/>
  </div>
    </>
  )
}

export default CorporrateGiftingHome
